import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  FlatList,
  Image,
  ActivityIndicator,
  useColorScheme,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';

// 模拟食物数据，实际应用中可能需要从API或本地数据库获取
const mockFoodData = [
  {
    id: '1',
    name: '米饭',
    pinyin: 'mifan',
    category: '谷物类',
    nutrients: { calories: 116, protein: 2.6, carbs: 25.6, fat: 0.3 },
    imageUrl: 'https://via.placeholder.com/60',
    portion: { default: 100, unit: '克' },
  },
  {
    id: '2',
    name: '全麦面包',
    pinyin: 'quanmaimianbao',
    category: '谷物类',
    nutrients: { calories: 265, protein: 9.0, carbs: 49.0, fat: 3.2 },
    imageUrl: 'https://via.placeholder.com/60',
    portion: { default: 100, unit: '克' },
  },
  {
    id: '3',
    name: '鸡胸肉',
    pinyin: 'jixiongrou',
    category: '肉类',
    nutrients: { calories: 165, protein: 31.0, carbs: 0, fat: 3.6 },
    imageUrl: 'https://via.placeholder.com/60',
    portion: { default: 100, unit: '克' },
  },
  {
    id: '4',
    name: '三文鱼',
    pinyin: 'sanwenyu',
    category: '海鲜类',
    nutrients: { calories: 206, protein: 22.0, carbs: 0, fat: 13.0 },
    imageUrl: 'https://via.placeholder.com/60',
    portion: { default: 100, unit: '克' },
  },
  {
    id: '5',
    name: '西兰花',
    pinyin: 'xilanhua',
    category: '蔬菜类',
    nutrients: { calories: 34, protein: 2.8, carbs: 6.6, fat: 0.4 },
    imageUrl: 'https://via.placeholder.com/60',
    portion: { default: 100, unit: '克' },
  },
  {
    id: '6',
    name: '苹果',
    pinyin: 'pingguo',
    category: '水果类',
    nutrients: { calories: 52, protein: 0.3, carbs: 13.8, fat: 0.2 },
    imageUrl: 'https://via.placeholder.com/60',
    portion: { default: 100, unit: '克' },
  },
  {
    id: '7',
    name: '牛奶',
    pinyin: 'niunai',
    category: '乳制品',
    nutrients: { calories: 42, protein: 3.4, carbs: 5.0, fat: 1.0 },
    imageUrl: 'https://via.placeholder.com/60',
    portion: { default: 100, unit: '毫升' },
  },
  {
    id: '8',
    name: '橄榄油',
    pinyin: 'ganlanyu',
    category: '油脂类',
    nutrients: { calories: 884, protein: 0, carbs: 0, fat: 100 },
    imageUrl: 'https://via.placeholder.com/60',
    portion: { default: 15, unit: '毫升' },
  },
  {
    id: '9',
    name: '巧克力',
    pinyin: 'qiaokeli',
    category: '零食饮料',
    nutrients: { calories: 546, protein: 4.9, carbs: 61.0, fat: 31.0 },
    imageUrl: 'https://via.placeholder.com/60',
    portion: { default: 100, unit: '克' },
  },
  {
    id: '10',
    name: '豆腐',
    pinyin: 'doufu',
    category: '蛋白质类',
    nutrients: { calories: 76, protein: 8.1, carbs: 1.9, fat: 4.2 },
    imageUrl: 'https://via.placeholder.com/60',
    portion: { default: 100, unit: '克' },
  },
];

const FoodSearchScreen = ({ route, navigation }) => {
  const isDarkMode = useColorScheme() === 'dark';
  const { searchQuery, category } = route.params || {};
  const [searchText, setSearchText] = useState(searchQuery || '');
  const [isLoading, setIsLoading] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [recentlyViewed, setRecentlyViewed] = useState([]);
  
  useEffect(() => {
    // 初始化时，如果有搜索或分类参数，立即执行搜索
    if (searchQuery) {
      performSearch(searchQuery);
    } else if (category) {
      filterByCategory(category);
    } else {
      // 显示最近查看的食物
      loadRecentlyViewed();
    }
  }, [searchQuery, category]);
  
  // 模拟加载最近查看的食物
  const loadRecentlyViewed = () => {
    // 在实际应用中，这些数据应该从本地存储或数据库中获取
    setRecentlyViewed(mockFoodData.slice(0, 3));
  };
  
  // 搜索功能
  const performSearch = (query) => {
    if (!query.trim()) return;
    
    setIsLoading(true);
    
    // 模拟API请求延迟
    setTimeout(() => {
      const results = mockFoodData.filter(food => 
        food.name.toLowerCase().includes(query.toLowerCase()) || 
        food.pinyin.toLowerCase().includes(query.toLowerCase())
      );
      
      setSearchResults(results);
      setIsLoading(false);
    }, 500);
  };
  
  // 按分类筛选
  const filterByCategory = (categoryName) => {
    setIsLoading(true);
    
    setTimeout(() => {
      const results = mockFoodData.filter(food => 
        food.category === categoryName
      );
      
      setSearchResults(results);
      setIsLoading(false);
    }, 500);
  };
  
  // 渲染食物列表项
  const renderFoodItem = ({ item }) => (
    <TouchableOpacity
      style={{
        flexDirection: 'row',
        padding: 16,
        borderBottomWidth: 1,
        borderBottomColor: isDarkMode ? '#7284a8' : '#e5e7eb',
        backgroundColor: isDarkMode ? '#a9b6d0' : 'white',
        borderRadius: 8,
        marginBottom: 8,
      }}
      onPress={() => navigation.navigate('FoodDetail', { foodId: item.id })}
    >
      <Image
        source={{ uri: item.imageUrl }}
        style={{
          width: 60,
          height: 60,
          borderRadius: 8,
          marginRight: 16,
        }}
      />
      <View style={{ flex: 1 }}>
        <Text style={{
          fontSize: 16,
          fontWeight: 'bold',
          marginBottom: 4,
          color: isDarkMode ? 'white' : '#1f2937',
        }}>
          {item.name}
        </Text>
        <Text style={{
          fontSize: 14,
          color: isDarkMode ? '#e0e0e0' : '#6b7280',
          marginBottom: 4,
        }}>
          {item.category}
        </Text>
        <Text style={{
          fontSize: 14,
          color: isDarkMode ? '#e0e0e0' : '#6b7280',
        }}>
          {item.nutrients.calories} 千卡 / {item.portion.default}{item.portion.unit}
        </Text>
      </View>
      <Ionicons name="chevron-forward" size={24} color={isDarkMode ? '#e0e0e0' : '#9ca3af'} />
    </TouchableOpacity>
  );
  
  const handleSearch = () => {
    performSearch(searchText);
  };
  
  return (
    <View style={{ 
      flex: 1, 
      backgroundColor: isDarkMode ? '#8fa0c1' : '#f3f4f6',
      padding: 16,
    }}>
      {/* 搜索框 */}
      <View style={{
        flexDirection: 'row',
        marginBottom: 16,
        backgroundColor: isDarkMode ? '#a9b6d0' : 'white',
        borderRadius: 12,
        padding: 4,
        alignItems: 'center',
      }}>
        <TextInput
          style={{
            flex: 1,
            paddingVertical: 12,
            paddingHorizontal: 16,
            fontSize: 16,
            color: isDarkMode ? 'white' : '#1f2937',
          }}
          placeholder="搜索食物（支持拼音/关键词）"
          placeholderTextColor={isDarkMode ? '#e0e0e0' : '#9ca3af'}
          value={searchText}
          onChangeText={setSearchText}
          returnKeyType="search"
          onSubmitEditing={handleSearch}
        />
        <TouchableOpacity
          onPress={handleSearch}
          style={{
            padding: 12,
            borderRadius: 8,
            backgroundColor: '#2563eb',
            marginRight: 4,
          }}
        >
          <Ionicons name="search" size={24} color="white" />
        </TouchableOpacity>
      </View>
      
      {/* 当前分类标题 */}
      {category && (
        <View style={{ marginBottom: 16 }}>
          <Text style={{
            fontSize: 18,
            fontWeight: 'bold',
            color: isDarkMode ? 'white' : '#1f2937',
          }}>
            {category}
          </Text>
        </View>
      )}
      
      {/* 加载指示器 */}
      {isLoading ? (
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
          <ActivityIndicator size="large" color="#2563eb" />
          <Text style={{
            marginTop: 16,
            fontSize: 16,
            color: isDarkMode ? 'white' : '#6b7280',
          }}>
            正在搜索...
          </Text>
        </View>
      ) : (
        <>
          {/* 搜索结果 */}
          {searchResults.length > 0 ? (
            <FlatList
              data={searchResults}
              keyExtractor={(item) => item.id}
              renderItem={renderFoodItem}
              showsVerticalScrollIndicator={false}
              ListHeaderComponent={
                <Text style={{
                  fontSize: 16,
                  marginBottom: 12,
                  color: isDarkMode ? 'white' : '#4b5563',
                }}>
                  找到 {searchResults.length} 个结果
                </Text>
              }
            />
          ) : (
            // 没有搜索结果或初始状态
            <View style={{ flex: 1 }}>
              {searchText || category ? (
                <Text style={{
                  fontSize: 16,
                  textAlign: 'center',
                  marginTop: 24,
                  color: isDarkMode ? 'white' : '#6b7280',
                }}>
                  没有找到匹配的食物
                </Text>
              ) : (
                <View>
                  <Text style={{
                    fontSize: 16,
                    fontWeight: 'bold',
                    marginBottom: 16,
                    color: isDarkMode ? 'white' : '#1f2937',
                  }}>
                    最近查看
                  </Text>
                  {recentlyViewed.length > 0 ? (
                    <FlatList
                      data={recentlyViewed}
                      keyExtractor={(item) => item.id}
                      renderItem={renderFoodItem}
                      showsVerticalScrollIndicator={false}
                    />
                  ) : (
                    <Text style={{
                      fontSize: 16,
                      color: isDarkMode ? 'white' : '#6b7280',
                      textAlign: 'center',
                      marginTop: 16,
                    }}>
                      暂无最近查看记录
                    </Text>
                  )}
                </View>
              )}
            </View>
          )}
        </>
      )}
    </View>
  );
};

export default FoodSearchScreen; 